module.exports = __webpack_public_path__ + "img/Manu_C_.fab83e9b.jpg";